import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import { MenuItems as HeadlessMenuItems } from '@headlessui/react';
import { useMenuItemsStyles } from './MenuItems.Styles';
export const MenuItems = ({ children, className, styled = true, ...props }) => {
    const theme = useTheme();
    const styles = useMenuItemsStyles({
        ...{},
        theme
    });
    return (_jsx(HeadlessMenuItems, { className: `${className} ${styled ? styles.menu : undefined}`, ...props, children: children }));
};
